module.exports = __webpack_public_path__ + "static/media/repairRedesign.8f309fec.svg";